import { strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";

import { mapDtoToEquipmentPoints } from "../model";
import type { EquipmentPoints } from "../model/types";

export const getCurrentEquipmentPoint = async (
  equipmentType: string,
  pageCount: number,
) => {
  const filters =
    equipmentType !== "all"
      ? {
          equipments_types: {
            uid: {
              $in: [equipmentType],
            },
          },
        }
      : {};

  const searchParams = {
    sort: ["createdAt:desc"],
    pagination: {
      page: pageCount || 1,
      pageSize: 6,
    },
    filters: { ...filters },
    populate: {
      photos: {
        populate: "*",
      },
      equipments_types: {
        populate: "*",
      },
      workTimeList: {
        populate: "*",
      },
    },
  };

  const equipmentsPoints = strapiClient.collection("equipments-points");

  const points = await equipmentsPoints.find({
    ...searchParams,
  });

  return rebuild(mapDtoToEquipmentPoints(points)) as EquipmentPoints;
};
